<template>
    <div>
        <b-row>
            <b-col>
                <b-table :items="preparedEntries"
                         :fields="fields"
                         small
                         sticky-header
                         striped>
                         <template #cell(in)="data">
                             <div v-if="!data.value.timestamp">
                                 <span>{{ data.value.date }}</span>
                             </div>
                             <div v-else>
                                <span class="mr-2">{{ data.value.date }}</span>
                                <b-button v-if="showEditLink(data)" size="sm" @click="editEntry(data.item, data.field)" variant="outline-secondary"><b-icon-pencil-square></b-icon-pencil-square></b-button>
                            </div>
                         </template>

                         <template #cell(out)="data">
                            <span class="mr-2">{{ data.value.date }}</span>
                            <b-button v-if="showEditLink(data)" size="sm" @click="editEntry(data.item, data.field)" variant="outline-secondary"><b-icon-pencil-square></b-icon-pencil-square></b-button>
                         </template>
                </b-table>
            </b-col>
        </b-row>

        <b-modal id="editEntryModal"
             title="Edit Entry"
             :size="editable ? 'lg' : 'md'"
             scrollable
             button-size="sm"
             centered
             style="height: 500px">
            <entry :entry="entry" @dateChange="entryChange"></entry>

            <template #modal-footer="{  }">
                <b-button size="sm" class="mb-0" @click="saveEntry" variant="success">
                    <b-icon-check-square-fill></b-icon-check-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Save</span>
                </b-button>

                <b-button size="sm" class="mb-0" @click="cancelSave" variant="secondary">
                    <b-icon-x-square-fill></b-icon-x-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Discard</span>
                </b-button>
            </template>
    </b-modal>
    </div>
</template>

<script>
    import timecardApi from "@/api/timecard";
    import Entry from "@/components/employees/Entry";
    import moment from "moment";
    import utils from "../mixins/utils";

    export default {
        name: "Timecard",
        mixins: [ timecardApi, utils ],
        components: { Entry },
        props: [ 'entries', 'paidTimeOff', 'editable' ],
        data() {
            return {
                fields: [
                    { key: 'in', label: 'In' },
                    { key: 'out', label: 'Out' },
                    { key: 'hours', label: 'Hours' },
                ],
                entry: {},
                editedDate: null,
            };
        },
        methods: {
            entryChange(date) {
                this.editedDate = date;
            },
            editEntry(entry, field) {
                this.entry = entry[field.key];
                this.$bvModal.show('editEntryModal');
            },
            async saveEntry() {
                try {
                    await this.updateEntry(this.entry.id, { date: this.editedDate });
                    this.entry = {};
                    this.$bvModal.hide('editEntryModal');
                    this.$emit('reloadTimecard');
                } catch (err) {
                    this.showError(err);

                    console.log(err);
                }
            },
            cancelSave() {
                this.entry = {};
                this.$bvModal.hide('editEntryModal');
            },
            showEditLink(data) {
                return data.value.date && !data.item._rowVariant && this.editable;
            }
        },
        computed: {
            preparedEntries() {
                let entries = [];

                let total = 0;

                for (let i = 0; i < this.entries.length; i++) {
                    let nextField = this.entries[i+1];

                    if (this.entries[i].type === 'in') {
                        let inDate = moment(this.entries[i].date);
                        let outDate = nextField ? moment(nextField.date) : moment();

                        let duration = moment.duration(outDate.diff(inDate));
                        let hours = duration.asHours();

                        let entry = {
                            in: { date: moment(this.entries[i].date).format('M/D/YYYY h:mma'), id: this.entries[i]._id, timestamp: this.entries[i].date } ,
                            hours: hours.toFixed(2)
                        };

                        if (nextField) {
                            entry.out = { date: moment(nextField.date).format('M/D/YYYY h:mma'), id: nextField._id, timestamp: nextField.date };
                        }

                        entries.push(entry);

                        total += parseFloat(hours);
                    }
                }

                for (let i = 0; i < this.paidTimeOff.length; i++) {
                    let entry = {
                        in: { date: this.paidTimeOff[i].reason || 'Paid Time Off' },
                        // out: moment(this.paidTimeOff[i].date).format('M/D/YYYY'),
                        hours: '8.00',
                        _rowVariant: 'secondary',
                    };

                    total += parseFloat(8);

                    entries.push(entry);
                }

                entries.push({ hours: total.toFixed(2), _rowVariant: 'success' });

                return entries;
            }
        }
    }
</script>

<style scoped>
</style>